import bsCustomFileInput from 'bs-custom-file-input';
import { Formik } from 'formik';
import { useContext, useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { mixed, object, setLocale } from 'yup';
import { confirm } from '../../components/CompUtils/ConfirmDialog';
import ErrorMsg from '../../components/CompUtils/ErrorMsg';
import LinkBtn from '../../components/CompUtils/LinkBtn';
import { setNotification } from '../../components/GlobalFeedback/feedbackSlice';
import { useCheckRoles } from '../../components/hooks';
import { ROLES } from '../../const';
import es from '../../yup-es';
import './CVItemStyles.css';
import { cargarAltDoc, cargarDoc, deleteItem, verDoc } from './cvSlice';
import { SeccionContext } from './itemTypes';

const useStyles = createUseStyles({
  itemHeader: {
    borderBottom: '1px solid black',
  },
  itemTitle: {
    textTransform: 'uppercase',
    fontSize: 14,
    fontWeight: 700,
  },
  validInfo: {
    position: 'absolute',
    zIndex: 10,
    top: 5,
    fontWeight: 'bold',
    backgroundColor: 'rgba(255,255,255,.6)',
    fontSize: 18,
  },
});
export default ({
  titleKey,
  titleValue = null,
  item,
  nameMap,
  realItem,
  acciones = true,
  order = null,
  altDoc = false,
  validarItems = false,
  idItems,
}) => {
  const classes = useStyles();

  const notif = {
    timeout: 750,
    msg: 'Operación exitosa',
    variant: 'success',
  };

  //Contexto proviniente del seccionContent en itemTypes.js
  const { handleOpen, setInitialValues, setFormTitle, type } = useContext(SeccionContext);
  const dispatch = useDispatch();

  const isAdmin = useCheckRoles(ROLES.ADMIN);

  const [errorMsg, setErrorMsg] = useState('');
  const [showFileModal, setShowFileModal] = useState(false);
  const [showAltFileModal, setShowAltFileModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const idAValidar = realItem.id;
  const [validadoManualmente, setValidadoManualmente] = useState(false);

  useEffect(() => {
    setValidated(realItem.validado);
    setValidadoManualmente(realItem.validado); //Agregue esto
  }, []);

  const removeErrorMsg = () => setErrorMsg('');

  const handleEdit = () => {
    setInitialValues(realItem);
    setFormTitle('Editar');
    handleOpen();
  };

  const handleRemove = async () => {
    if (await confirm('¿Está seguro que desea eliminar el item?', 'Confirmar eliminación')) {
      dispatch(
        deleteItem({
          seccionKey: type,
          itemId: realItem.id,
        }),
      ).then((action) => {
        if (action.error) {
          setErrorMsg('Error al intentar eliminar el item.');
        } else {
          dispatch(setNotification(notif));
        }
      });
    }
  };

  const handleFileModal = (show) => {
    setShowFileModal(show);
  };
  const handleAltFileModal = (show) => {
    setShowAltFileModal(show);
  };

  order = order || Object.keys(item).sort((a, b) => a.localeCompare(b));

  return (
    <Container>
      <Row className={`align-items-end ${classes.itemHeader}`}>
        <Col sm={9} className="order-last order-sm-first">
          <span className={classes.itemTitle}>{titleValue || item[titleKey]}</span>
        </Col>
        <Col className="text-right">
          {acciones && (
            <>
              <LinkBtn title="Editar item" onClick={handleEdit} disabled={validated}>
                <i className="fa fa-fw fa-edit"></i>
              </LinkBtn>
              <LinkBtn title="Eliminar item" onClick={handleRemove} disabled={validated}>
                <i className="fa fa-fw fa-trash text-danger"></i>
              </LinkBtn>
            </>
          )}
          {console.log(validarItems || validated)}
          {(validarItems || validated) && (
            <ValidarBtn
              validated={validated}
              validadoManualmente={validadoManualmente}
              classes={classes}
              hasRole={isAdmin}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <ErrorMsg msg={errorMsg} callback={removeErrorMsg} />
        </Col>
      </Row>
      <Row>
        <Col>
          <ul className="itemData">
            {order?.map(
              (el) =>
                el !== titleKey &&
                item[el] &&
                nameMap[el] && (
                  <li key={el}>
                    <span className="itemKey">{nameMap[el]}: </span>
                    <span className="itemValue">{item[el]}</span>
                  </li>
                ),
            )}
          </ul>
          <div className="d-flex flex-row justify-content-start">
            <div className="d-flex">
              {/* SI ES SOLO ANTECEDENTE LABORAL ENTRA ACA */}
              {item.idAntecedenteLaboralCv && (
                <>
                  {!item.documentoPath && (
                    <>
                      <LinkBtn
                        title={
                          altDoc
                            ? 'Cargar certificación de servicios'
                            : 'Cargar documentación a validar'
                        }
                        onClick={() => handleFileModal(true)}
                        disabled={validated}>
                        <i className="fa fa-fw fa-file-pdf-o"></i> Adjuntar certificación de
                        servicios
                      </LinkBtn>
                    </>
                  )}
                  {altDoc && !item.documentoPath2 && (
                    <LinkBtn
                      title={'Cargar certificación de funciones'}
                      onClick={() => handleAltFileModal(true)}
                      disabled={validated}>
                      <i className="fa fa-fw fa-file-text-o"></i> Adjuntar certificación de
                      funciones
                    </LinkBtn>
                  )}
                </>
              )}
              {!item.documentoPath && !item.idAntecedenteLaboralCv && (
                <>
                  <LinkBtn
                    title={'Cargar documentación a validar'}
                    onClick={() => handleFileModal(true)}
                    disabled={validated}>
                    <i className="fa fa-fw fa-file-pdf-o"></i> Adjuntar documentación
                  </LinkBtn>
                </>
              )}
              {/* {altDoc && !item.documentoPath2 && (
                <LinkBtn
                  title={'Cargar certificación de funciones'}
                  onClick={() => handleAltFileModal(true)}
                  disabled={validated}>
                  <i className="fa fa-fw fa-file-text-o"></i> Adjuntar certificación de funciones
                </LinkBtn>
              )} */}
            </div>
          </div>
        </Col>
      </Row>
      <FileModal
        show={showFileModal}
        setShow={handleFileModal}
        item={realItem}
        seccionKey={type}
        title={altDoc ? 'Cargar certificación de servicios' : 'Cargar documentación a validar'}
      />
      {altDoc && (
        <FileModal
          show={showAltFileModal}
          setShow={handleAltFileModal}
          item={realItem}
          seccionKey={type}
          altDoc
          altDocPath={realItem.documentoPath2}
          title="Cargar certificación de funciones"
        />
      )}
    </Container>
  );
};

const ValidarBtn = ({ validadoManualmente }) => {
  let comp;

  if (validadoManualmente) {
    comp = (
      <span className="fa-stack">
        <i
          style={{ opacity: 0.6, cursor: 'not-allowed' }}
          className="fa fa-fw fa-certificate fa-stack-2x text-success"></i>
        <i
          style={{ opacity: 0.6, cursor: 'not-allowed' }}
          className={`fa fa-fw fa-check fa-stack-1x fa-inverse`}></i>
      </span>
    );
  } else {
    comp = (
      <span className="fa-stack" title="Item sin validar">
        <i
          style={{ opacity: 0.6, cursor: 'not-allowed' }}
          className="fa fa-fw fa-certificate text-info fa-stack-2x"></i>
        <i
          style={{ opacity: 0.6, cursor: 'not-allowed' }}
          className={`fa fa-fw fa-question fa-stack-1x fa-inverse`}></i>
      </span>
    );
  }

  return comp;
};

const FileModal = ({
  seccionKey,
  item,
  setShow,
  altDoc = false,
  altDocPath = null,
  title = 'Cargar documentación a validar',
  ...rest
}) => {
  const dispatch = useDispatch();
  const id = item.id;
  const docPath = altDocPath || item.documentoPath;

  useEffect(() => {
    bsCustomFileInput.init();
  });

  const handleClose = (onClose) => {
    setShow(false);
    onClose();
  };
  const submitHandler = (values, actions) => {
    const action = altDoc ? cargarAltDoc : cargarDoc;
    dispatch(
      action({
        itemId: id,
        seccionKey,
        file: values.doc,
      }),
    ).then(() => handleClose(actions.resetForm));
  };

  const verDocumento = () => {
    dispatch(verDoc({ docPath }));
  };

  setLocale(es);
  const SUPPORTED_FORMATS = ['application/pdf'];
  const schema = object({
    doc: mixed()
      .test('required', 'Seleccione un archivo a cargar', (value) => !!value.name)
      .test('fileType', 'Solo se permiten archivos .PDF', (value) =>
        SUPPORTED_FORMATS.includes(value.type),
      ),
  });

  const previewDoc = item.documentoPath ? (
    <LinkBtn onClick={verDocumento}>Visualizar documentación presentada</LinkBtn>
  ) : (
    ''
  );

  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      onSubmit={submitHandler}
      validateOnChange={false}
      initialValues={{ doc: {} }}>
      {(formik) => {
        return (
          <Form noValidate onSubmit={formik.handleSubmit}>
            <Modal dialogClassName="my-modal" {...rest}>
              <Modal.Header>
                <Modal.Title as="h5">{title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {previewDoc}
                <Form.File id="doc" custom>
                  <Form.File.Input
                    name="doc"
                    accept=".pdf"
                    type="file"
                    isInvalid={!!formik.errors.doc}
                    onChange={(ev) => {
                      formik.setFieldValue('doc', ev.currentTarget.files[0]);
                    }}
                  />
                  <Form.File.Label data-browse="Cargar archivo">Seleccione</Form.File.Label>
                  <label>Solo se permiten archivos .PDF</label>
                  <Form.Control.Feedback type="invalid">{formik.errors.doc}</Form.Control.Feedback>
                </Form.File>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => handleClose(formik.resetForm)}>
                  Cancelar
                </Button>
                <Button variant="primary" onClick={formik.handleSubmit}>
                  Aceptar
                </Button>
              </Modal.Footer>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export const DocLink = ({ docPath, docDate, msg = 'Visualizar' }) => {
  const [errorMsg, setErrorMsg] = useState('');
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(verDoc({ docPath })).then((action) => {
      if (action.error) {
        setErrorMsg('Error al intentar recuperar el archivo.');
      }
    });
  };

  return (
    <>
      <LinkBtn onClick={handleClick}>{msg}</LinkBtn>
      <br />
      <>
        <span style={{ fontStyle: 'normal', fontWeight: 'bold' }}>
          Fecha de carga del documento:{' '}
        </span>
        <span className="itemValue">{docDate}</span>
      </>
      <ErrorMsg msg={errorMsg} callback={() => setErrorMsg('')} />
    </>
  );
};

export const MultiLineData = ({ texto }) => {
  const lineas = texto ? texto.split('\n') : '';
  return lineas.length <= 1 ? (
    <span>{texto}</span>
  ) : (
    <div style={{ paddingLeft: 15 }}>
      {lineas.map((linea, idx) => (
        <span key={idx}>
          <span>{linea}</span>
          <br />
        </span>
      ))}
    </div>
  );
};
